import { ConditionalOperator as a } from "../../../../node_modules/gridify-client/dist/index.esm.js";
const n = { LessThan: "LessThanOrEqual", Equals: "Equal", GreaterThan: "GreaterThanOrEqual", NotEqual: "NotEqual" }, o = (a2) => "comparison" === a2.type, r = (o2, r2) => {
  const { key: e, operation: t, value: i, range: s } = o2;
  if ("Range" === t) {
    const { min: n2, max: o3 } = s;
    return r2.startGroup().addCondition(e, a.GreaterThanOrEqual, n2).and().addCondition(e, a.LessThanOrEqual, o3).endGroup();
  }
  const d = n[t];
  return r2.addCondition(e, a[d], i);
};
export {
  o as isComparison,
  r as serializeComparison
};
//# sourceMappingURL=serializeComparison.js.map
